import {
  REMIND_CONTROL_PIN_INIT,
  REMIND_CONTROL_PIN_SUCCESS,
  REMIND_CONTROL_PIN_ERROR,
} from '../../actions/channelBlocker/constants';

const initialState = {
  inProgress: false,
  success: false,
  error: null,
  data: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REMIND_CONTROL_PIN_INIT: {
      return {
        ...initialState,
        inProgress: true,
      };
    }
    case REMIND_CONTROL_PIN_SUCCESS: {
      return {
        inProgress: false,
        success: true,
        error: null,
        data: action.payload,
      };
    }
    case REMIND_CONTROL_PIN_ERROR: {
      return {
        inProgress: false,
        success: false,
        error: action.error,
        data: null,
      };
    }
    default:
      return state;
  }
};
